module.exports = __webpack_public_path__ + "static/media/parakeet-logo@2x.84691d78.png";